import { RouterType } from '@online-webinar/router';
import { VideoEditorPage } from '@online-webinar/video-editor';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/edit-video'].update({
        staticData: { title: { page: 'Editor.PageHeading', forWebinar: true } },
        component: authGuard(VideoEditorPage, { canBroadcast: true })
    });
};
